// This function is to be used as default prop value
// and avoids 'unexpected empty arrow function' code smell
export const noop: () => void = () => undefined;
